import axios from 'axios'
//const url = 'https://localhost:44338/ambulance.asmx/'
export const PROD_URL = 'https://mgmvc1.mgmhealthcare.in/'
const base_path = `${PROD_URL}service/`
//const base_path = 'https://mgmvc1.mgmhealthcare.in/service/'

const url = base_path + 'ambulance.asmx/';

export const sendWhatsapp = (data: any) => {
    const config = {
        method: "post",
        maxBodyLength: Infinity,
       // url : 'https://localhost:44338/ambulance.asmx/sendWhatsApp',
        url: `${url}sendWhatsApp`,
        headers: {
            'Content-Type': 'application/json'
        },
        data
    };

    return axios.request(config)
        .then((response: any) => {
            return JSON.parse(response.data.d)
        })
        .catch((error: any) => {
            console.log(error);
            return error
        });
}
export const callAPIForLogin = (data: any) => {
    const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${url}login`,
        headers: {
            'Content-Type': 'application/json'
        },
        data
    };

    return axios.request(config)
        .then((response: any) => {
            return JSON.parse(response.data.d.result)
        })
        .catch((error: any) => {
            console.log(error);
            return error
        });

}

export const callAPIForAutoLogin = (data: any) => {
    const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${url}auto_login`,
        headers: {
            'Content-Type': 'application/json'
        },
        data
    };

    return axios.request(config)
        .then((response: any) => {
            return JSON.parse(response.data.d.result)
        })
        .catch((error: any) => {
            console.log(error);
            return error
        });

}
export const getBedSideMonitorData = (fromIndex: number, toIndex: number) => {

    let data = JSON.stringify({
        "patient_id": 4,
        "fromIndex": fromIndex,
        "toIndex": toIndex
    });

    let config = {
        method: 'post',
        maxBodyLength: Infinity,
        url: base_path + '/bed_side_monitor.asmx/getBedSideMonitorData',
        headers: {
            'Content-Type': 'application/json'
        },
        data: data
    };

    return axios.request(config)
        .then((response: any) => {
            return response.data.d
        })
        .catch((error: any) => {
            console.log(error);
        });

}
export const callAPIForQuery = (data: any, method: string = "post", dont_alert = false) => {
    const config = {
        method,
        maxBodyLength: Infinity,
        url: `${url}/query`,
        headers: {
            'Content-Type': 'application/json'
        },
        data
    };

    return axios.request(config)
        .then((response: any) => {
            if (response.data.d.error) {
                if (!dont_alert) alert(response.data.d.error)
                return { error: response.data.d.error }
            } else {
                return JSON.parse(response.data.d.result)
            }
        })
        .catch((error: any) => {
            console.log(error);
            return error
        });

}